import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { VirtualConnectionsDisplayGridRowDataFragmentGql } from './VirtualConnectionsDisplayGridRowDataFragmentGql';

export const UpstreamVirtualConnectionsFilteredByFieldQueryGql: DocumentNode = gql`
query UpstreamVirtualConnectionsFilteredByFieldQuery(
  $selectedFieldId: ID!,
  $first: Int!,
  $offset: Int!,
  $orderBy: VirtualConnectionSortOrder!,
  $publishedConnectionsLineageEnabled: Boolean!,
) {
  fieldsConnection(filter: {id: $selectedFieldId}) {
    nodes {
      upstreamVirtualConnectionsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...VirtualConnectionsDisplayGridRowDataFragment
        }
      }
      maxDownstreamDatasources: upstreamTablesConnection(
        orderBy: { field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC }
        first: 1
      ) {
        nodes {
          downstreamDatasourcesConnection { totalCount }
        }
      }
      maxDownstreamWorkbooks: upstreamTablesConnection(
        orderBy: { field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC }
        first: 1
      ) {
        nodes {
          downstreamWorkbooksConnection { totalCount }
        }
      }
    }
  }
}
${VirtualConnectionsDisplayGridRowDataFragmentGql}
`;
